import ReactLayer, {IProps as ILayerProps} from '@tolkam/react-modal-layer';
import Close from '~/ui/react/components/Icon/Close';
import './styles';

const Layer = function Layer(props: ILayerProps) {
    const {mode} = props;

    props = {
        ...props,
        classNameLayer: 'jc-layer',
        classPrefixBody: '',
        classPrefixBackdrop: '',
        classModifiersPrefix: '',
        classModesPrefix: '',
    };

    if(!mode || mode === 'overlay' || mode === 'panel') {
        props.headerChildren = <span
            onClick={props.onCloseRequest}
            className={'close comp-button -icon'}>
            <Close />
        </span>;
    }

    return <ReactLayer {...props} />;
}

export default Layer;
